import { Stack, Typography } from '@mui/material'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { ReactNode } from 'react'

interface Props {
  title: string
  label?: string
  children: ReactNode
}
export const VesselKPI = observer(({ title, label, children }: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Stack height='100%' width='100%' gap={theme.customSpacing.s}>
      <Typography variant='h4'>{title}</Typography>

      <Stack>
        {label && (
          <Typography variant='subtitle2' color='secondary'>
            {label}
          </Typography>
        )}
        {children}
      </Stack>
    </Stack>
  )
})
